import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import FR from './locales/fr.json';

const resources = {
  fr: { translation: FR },
};

const lng = typeof navigator !== 'undefined' ? navigator.language.split('-')[0] : 'fr';

const i18nConfig = {
  resources,
  lng,
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init(i18nConfig);
}

export default i18n;
